import { render, staticRenderFns } from "./Pergunta.vue?vue&type=template&id=6e286551&scoped=true"
import script from "./Pergunta.vue?vue&type=script&lang=ts"
export * from "./Pergunta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e286551",
  null
  
)

export default component.exports